module.exports = __webpack_public_path__ + "img/deadline-icon.9797ac9e.png";